import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-base_manage",
  "use": "icon-base_manage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-base_manage\"><path d=\"M941.44 865.472a447.808 447.808 0 0 0-397.44-320V352h128a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32H352a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h128v193.472a447.84 447.84 0 0 0-397.504 320A64 64 0 1 0 160 928c0-16.48-6.4-31.36-16.64-42.688A384 384 0 0 1 480 609.504v263.392c-19.04 11.072-32 31.488-32 55.136a64 64 0 0 0 128 0c0-23.616-12.96-44.032-32-55.136v-263.392a383.936 383.936 0 0 1 336.608 275.872A63.36 63.36 0 0 0 864 928a64 64 0 0 0 128 0 64 64 0 0 0-50.56-62.528z\" p-id=\"2858\" /><path d=\"M288 480h77.472a32 32 0 0 0 0-64H288a32 32 0 0 1-32-32V128a32 32 0 0 1 32-32h448a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32h-90.624a32 32 0 0 0 0 64H736a96 96 0 0 0 96-96V128a96 96 0 0 0-96-96H288a96 96 0 0 0-96 96v256a96 96 0 0 0 96 96z\" p-id=\"2859\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/base_manage.svg
// module id = g4lb
// module chunks = 111